import React,{useState,useEffect} from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import WhatULearnAddMoreSubCourse from "./WhatULearnAddMoreSubCourse";

import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus} from 'lucide-react';
import AddHighlightsAddMoreSubCourse from "./AddHighlightsAddMoreSubCourse";
  
  
const AddHighlightsSubCourse= ({sendBackData,data})=>{ 
    const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
 
 const [itemArr, setItemArr] = useState(data);

     useEffect(() => {
        data.length !== 0?setItemArr(data):
        setItemArr([{ no:1, id: generateTimestamp()
          ,paragraph:"" },]);
          
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
   
const handleSendBackData=(e)=>{

    sendBackData(itemArr)
     
      }

    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.id !== id);
        setItemArr(filteredItems);
      };
      const updateItemParagraph = (id, Paragraph) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, paragraph :Paragraph } : item
        
        ); 
        
        setItemArr(updatedItems);
      };
     
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  
const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    id: item.id,
  }));
  setItemArr(reorderedItems);
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   
     return(<>
                      
    <div className="" >
           
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.id} 
          ><div
          className="drop-zone"
          onDragOver={(e) => {setHoveredDropZone(index);
            handleDragOver(e, index)
          }}
          onDrop={(e) => handleDrop(e, index)}
        
          style={{
            height: hoveredDropZone === index ?'60px':"0px",position:hoveredDropZone === index ?'relative':"",left:"0px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",top:"10px",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"20px":"0px"
           
          }}
        ></div>
            <div
             draggable 
                    
onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.id);setSelectedItemIndex(index);
             }}
             style={{
              cursor: 'move',
             
              
            }}  className={draggedIndex == item.id?"posFixed":"posRelative"  }
          
              onDragEnd={handleDragEnd}
            ><AddHighlightsAddMoreSubCourse index={index} key={item.id} 
        
         paragraph={item.paragraph}  id={item.id} 
           changeItemParagraph={updateItemParagraph } onRemove={removeItem} />
          </div>
          
          </div>)):'' }
    
    <div align="center">
<div align="center"  style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New Highlight</div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+2
      ,  paragraph:"" }])}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div> 
    <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div></div>

<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleSendBackData()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> Update Info </button>
 </div>
  
      
                                    
     </>)  
   }
   export default AddHighlightsSubCourse;